import {getPoiAllList, MapIconsByName} from "@/config/map-icons";
import {getBatchFuelPricesStatus} from "@/api/poi";
import Store from "@/store";

export const IconConfig = {
  'All Truck Stops': ['Truck Stops', 'Pilot/Flying J', 'Love’s', 'TA/Petro', 'KwikTrip/KwikStar'],
  'Parking and Rest Area': ['Parking', 'Rest Area', 'Walmarts', 'Hotels'],
  'Truck Service': ['Fuel', 'Weigh Stations', 'Truck Washes', 'Repair Shops', 'Tires'],
  'Dealers': ['Speedco', 'Thermo King', 'Volvo', 'Freightliner', 'Kenworth', 'Peterbilt', 'Utility Trailers', 'Carriers', 'Mack', 'International'],
  'Weigh Stations': ['Weigh Stations'],
  'Fuel': ['Truck Stops', 'Pilot/Flying J', 'Love’s', 'TA/Petro', 'KwikTrip/KwikStar'],
  // 'Fuel': ['Fuel']
}
export const TabConfig = {
  'All': ['All Truck Stops', 'Parking and Rest Area', 'Truck Service', 'Dealers'],
  'Truck Parking': ['All Truck Stops', 'Parking and Rest Area'],
  'Weigh Station': ['Weigh Stations'],
  'Fuel': ['All Truck Stops'],
  'Fuel Price': ['Fuel', 'All Truck Stops', 'Parking and Rest Area']
}

export const filterPoiByTab = (poiList, type) => {
  const poiTypes = [].concat(...TabConfig[type].map(itemName => IconConfig[itemName].map(x => MapIconsByName[x])))
  const typeCt = {};

  poiTypes.forEach(x => {
    if (x.points) {
      x.points.forEach(y => {
        typeCt[y.tid] ? typeCt[y.tid].add(y.sid) : (typeCt[y.tid] = new Set([y.sid]));
      })
    } else {
      typeCt[x.tid] ? typeCt[x.tid].add(x.sid) : (typeCt[x.tid] = new Set([x.sid]));
    }
  })
  return poiList.filter(x => typeCt[x.tid] && typeCt[x.tid].has(x.sid))
}

class PoiPartGetter {
  constructor() {
    this.isFailed = 0; // 0 -> success, 1 ->all fail, 2 -> partial failed
    this.retryList = []
    this.requestParams = null
  }
  SET_ALONE_ROUTE_ID(...args) {
    return Store.commit('map/SET_ALONE_ROUTE_ID', ...args)
  }
  SET_POI_ON_ROUTE(...args) {
    return Store.commit('map/SET_POI_ON_ROUTE', ...args)
  }
  calculateRouteAsidePoiAsync(...args) {
    return Store.dispatch('map/calculateRouteAsidePoi', ...args)
  }
  retry(callBack) {
    let uid = Date.now();
    this.SET_ALONE_ROUTE_ID(uid)
    let totalPoi = [...Store.state.map.poiOnRoute]
    let finishItem = 0
    const poiIds = new Set(totalPoi.map(item => item.pointId));
    let retryList = []
    let partsNum = this.retryList.length
    const resStatus = {
      success: 0,
      total: 0,
    }
    this.retryList.forEach(points => {
      this.calculateRouteAsidePoiAsync({...this.requestParams, points})
        .catch((error) => {
          if (uid !== Store.state.map.aloneRouteId) return
          retryList.push(points)
          throw error
        })
        .then(points => {
          if (uid !== Store.state.map.aloneRouteId) return
          totalPoi = totalPoi
            .concat(points.filter(x => poiIds.has(x.pointId) ? false : poiIds.add(x.pointId)))
            .sort((x, y) => x.distanceFromStart - y.distanceFromStart)
          this.SET_POI_ON_ROUTE(totalPoi);
          resStatus.success += 1;
        })
        .finally(() => {
          if (uid !== Store.state.map.aloneRouteId) return
          finishItem += 1;
          resStatus.total += 1;
          if(resStatus.total === partsNum) {
            if (resStatus.success === resStatus.total) {
              this.isFailed = 0;
            }
          }
          if (finishItem === partsNum) {
            this.retryList = retryList
            callBack && setTimeout(() => callBack(totalPoi, this.isFailed))
          }
        })
    })
  }
  get(callBack) {
    this.isFailed = 0; // 0 -> success, 1 ->all fail, 2 -> partial failed
    let uid = Date.now();
    this.SET_ALONE_ROUTE_ID(uid)
    const activeRoute = Store.state.tripPlan.activeRoute
    const points = activeRoute.routeType === 'fuelPlan' ? activeRoute.fuelPlanRoute.points : activeRoute.points

    let params = {
      filterBasis: getPoiAllList(),
      filterLabels: 'All Places',
      startPoint: points[0]
    }
    this.requestParams = params
    this.pageLoading = true
    let retryList = []
    let totalPoi = [];
    const poiIds = new Set();
    const partsNum = 30;
    const partLength = parseInt(points.length / partsNum)
    let finishItem = 0
    const resStatus = {
      success: 0,
      total: 0,
    }
    Array(partsNum).fill().map((_, index) =>
      index + 1 !== partsNum ?
        points.slice(index * partLength, (index + 1) * partLength) :
        points.slice(index * partLength)
    ).forEach(points => {
      this.calculateRouteAsidePoiAsync({...params, points})
        .catch((error) => {
          if (uid !== Store.state.map.aloneRouteId) return
          retryList.push(points)
          throw error
        })
        .then(points => {
          if (uid !== Store.state.map.aloneRouteId) return
          totalPoi = totalPoi
            .concat(points.filter(x => poiIds.has(x.pointId) ? false : poiIds.add(x.pointId)))
            .sort((x, y) => x.distanceFromStart - y.distanceFromStart)
          this.SET_POI_ON_ROUTE(totalPoi);
          resStatus.success += 1;
        })
        .finally(() => {
          if (uid !== Store.state.map.aloneRouteId) return
          this.pageLoading = false
          finishItem += 1;
          resStatus.total += 1;
          if(resStatus.total === partsNum) {
            if (!resStatus.success ) {
              this.isFailed = 1;
              this.SET_POI_ON_ROUTE([])
            } else if (resStatus.success < resStatus.total) {
              this.isFailed = 2;
            }
          }
          if (finishItem === partsNum) {
            this.retryList = retryList
            callBack && setTimeout(() => callBack(totalPoi, this.isFailed))
          }
        })
    })
  }
}
export const poiPartGetter = new PoiPartGetter()
export function getFuelPrice(pointIndexes) {
  const POIs = filterPoiByTab(pointIndexes, 'Fuel Price')
  return getBatchFuelPricesStatus(POIs.map(x => x.pointId)).then(resp => {
    const pCt = {}
    resp.res.data.results.forEach(x => pCt[x.id] = x)
    return pCt
  })
}

export function spGetFuelPrice() {
  return new Promise(resolve => {
    poiPartGetter.get((pointIndexes, isFailed) => {
      const POIs = filterPoiByTab(pointIndexes, 'Fuel Price')
      resolve([POIs, isFailed])
      // getBatchFuelPricesStatus(POIs.map(x => x.pointId)).then(resp => {
      //   const pCt = {}
      //   resp.res.data.results.forEach(x => pCt[x.id] = x)
      //   return res(POIs.filter(x => pCt[x.pointId]).map(x => {
      //     x.fuel = pCt[x.pointId];
      //     return x
      //   })).catch(error => {
      //     rej(error)
      //   })
      // })
    })
  })
}
